// Direct iPhone Safari Cart Fix
(function () {
  "use strict";

  // Check if we're on iPhone Safari
  const isIPhoneSafari =
    /iPhone/.test(navigator.userAgent) &&
    /Safari/.test(navigator.userAgent) &&
    !/Chrome/.test(navigator.userAgent);

  if (!isIPhoneSafari) {
    return;
  }

  // Override the fetch function for iPhone Safari
  const originalFetch = window.fetch;
  window.fetch = function (url, options = {}) {
    // Only modify cart add requests
    if (url.includes("/cart/add.js")) {
      // Ensure proper headers for iPhone Safari
      options.headers = options.headers || {};
      options.headers["X-Requested-With"] = "XMLHttpRequest";
      options.headers["Accept"] = "application/json";
      options.headers["Cache-Control"] = "no-cache";
      options.credentials = "same-origin";

      // Remove Content-Type to let browser set it for FormData
      delete options.headers["Content-Type"];
    }

    return originalFetch.call(this, url, options);
  };

  // Override cart drawer open method for iPhone Safari
  function fixCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      const originalOpen = cartDrawer.open;
      cartDrawer.open = function () {
        // Force visibility for iPhone Safari
        this.style.visibility = "visible";
        this.style.opacity = "1";
        this.classList.add("active");

        // Force inner drawer to slide in
        const drawerInner = this.querySelector(".drawer__inner");
        if (drawerInner) {
          drawerInner.style.transform = "translateX(0)";
          drawerInner.style.webkitTransform = "translateX(0)";
        }

        // Add body class
        document.body.classList.add("overflow-hidden");

        // Call original method if it exists
        if (typeof originalOpen === "function") {
          originalOpen.call(this);
        }
      };
    }
  }

  // Fix product form submission for iPhone Safari
  function fixProductForm() {
    const productForms = document.querySelectorAll("product-form");
    productForms.forEach((productForm) => {
      // Override the onSubmitHandler
      const originalHandler = productForm.onSubmitHandler;
      productForm.onSubmitHandler = function (evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") {
          return;
        }

        // Show loading state
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        const spinner = this.querySelector(".loading__spinner");
        if (spinner) spinner.classList.remove("hidden");

        // Get variant ID
        const variantId = this.variantIdInput.value;
        if (!variantId) {
          this.handleErrorMessage(
            "Product configuration error. Please refresh the page."
          );
          return;
        }

        // Create form data
        const formData = new FormData(this.form);

        // Add sections for cart drawer
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // Make the request
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
          },
          credentials: "same-origin",
          body: formData,
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `HTTP ${response.status}: ${response.statusText}`
              );
            }
            return response.json();
          })
          .then((data) => {
            // Handle success
            if (data.status) {
              // Error response
              this.handleErrorMessage(
                data.description || "Error adding to cart"
              );
              return;
            }

            // Success - update cart
            if (this.cart) {
              this.cart.renderContents(data);
            } else {
              window.location.href = "/cart";
            }
          })
          .catch((error) => {
            console.error("Cart add error:", error);
            this.handleErrorMessage(
              "Failed to add item to cart. Please try again."
            );
          })
          .finally(() => {
            // Reset button state
            this.submitButton.classList.remove("loading");
            this.submitButton.removeAttribute("aria-disabled");
            if (spinner) spinner.classList.add("hidden");
          });
      };
    });
  }

  // Apply fixes when page is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      fixCartDrawer();
      fixProductForm();
    });
  } else {
    fixCartDrawer();
    fixProductForm();
  }

  // Also apply after a delay
  setTimeout(function () {
    fixCartDrawer();
    fixProductForm();
  }, 1000);
})();
